<template>
    <div class="section">
        <div class="container-fluid">
            <div class="section">
                <div class="container ">
                    <div class="columns">
                        <div class="column is-5-desktop">
                            <h1 class="title has-text-centered">Create Transaction</h1>
                            <transition name="fade">
                                <div v-if="alertMessage" class="alert-message is-success has-text-centered">
                                    {{ alertMessage }}
                                </div>
                            </transition>
                            <form>
                                <div class="field select-client-field">
                                    <div class="control">
                                        <div class="client-name">{{ clientName }}</div>

                                        <button @click.prevent="getInvoices" class="button is-primary">Get Invoices</button>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <input v-model="amount"
                                               v-bind:class=""
                                               class="input"
                                               type="number"
                                               placeholder="Amount"
                                               required=""
                                               autofocus="">
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <datetime
                                                input-class="input"
                                                v-model="transactionDate"
                                                :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                                type="date"
                                                value-zone="local"
                                                zone="local"
                                                placeholder="Select date"
                                        ></datetime>
                                    </div>
                                </div>
                                <div class="field">
                                    <div class="control">
                                        <textarea v-model="description" class="textarea" placeholder="Description"></textarea>
                                    </div>
                                </div>

                                <div class="field">
                                    <div class="control text-center">
                                        <a v-if="amount - getAmountUsed >= 0" @click.prevent="createTransaction" class="button is-primary">Submit</a>
                                        <a @click="cancel" class="button is-danger"><span>Cancel</span></a>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="column is-offset-2-desktop">
                            <div v-if="amount - getAmountUsed < 0" class="error-alert">&nbsp;
                                The amount entered for individual invoice(s) exceeds the total payment the customer has made. Please check and retry.
                            </div>
                            <h1 v-else class="title has-text-centered">&nbsp;</h1>
                            <div class="client-amount-table-container">
                                <div class="card">
                                    <div class="card-content">
                                        <table class="table table-striped client-amount-table">
                                            <tr>
                                                <th colspan="5" class="">Deposits</th>
                                                <th>{{ getCurrency }}{{ transactionTotals.deposit | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Receivables</th>
                                                <th>{{ getCurrency }}{{ transactionTotals.receivables | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount received</th>
                                                <th>{{ getCurrency }}{{ amount | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount used for payments</th>
                                                <th>{{ getCurrency }}{{ getAmountUsed | formatNumber }}</th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount in Excess</th>
                                                <th>{{ getCurrency }}{{ amount - getAmountUsed |
                                                    formatNumber }}
                                                </th>
                                            </tr>
                                            <tr>
                                                <th colspan="5" class="">Amount refunded</th>
                                                <th>{{ getCurrency }}{{ transactionTotals.moneyOut | formatNumber }}</th>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div class="invoice-heading">
                                <h1 class="title has-text-centered">Unpaid Invoices</h1>
                            </div>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                    <tr>
                                        <th><span @click="setOrder('manager_id')" class="link">Invoice #</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Issue Date</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Chassis</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Due Amount</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Used Amount</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Deposit</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <unpaid-invoice-table-row v-for="(invoice, index) in unpaidInvoices"
                                                              :invoice="invoice" :invoiceDeposit="invoice.deposit" :invoiceAmountUsed="invoice.amount_used" :action="'add'" :transactionTotals="transactionTotals" :amount="amount"></unpaid-invoice-table-row>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="column">
                            <div class="invoice-heading">
                                <h1 class="title has-text-centered">Unpaid Multi Invoices</h1>
                            </div>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                    <tr>
                                        <th><span @click="setOrder('manager_id')" class="link">Invoice #</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Issue Date</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Due Amount</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Deposit</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <unpaid-multi-invoice-table-tr v-for="(multi_invoice, index) in unpaidMultiInvoices" :multiInvoice="multi_invoice" :transactionTotals="transactionTotals"></unpaid-multi-invoice-table-tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <unpaid-multi-invoices-modal :amount="amount"></unpaid-multi-invoices-modal>
    </div>

</template>
<script>
    import {ModelSelect} from 'vue-search-select'
    import apiUsers from './../../api/apiUsers'
    import {Datetime} from 'vue-datetime'
    import apiProformaInvoices from "../../api/apiProformaInvoices";
    import UnpaidClientMultiInvoiceTableRow from "./UnpaidClientMultiInvoiceTableRow";
    import UnpaidClientInvoiceTableRow from "./UnpaidClientInvoiceTableRow";
    import UnpaidInvoiceTableRow from "../Banking/UnpaidInvoiceTableRow";
    import UnpaidMultiInvoiceTableTr from "../Banking/UnpaidMultiInvoiceTableTr";
    import UnpaidMultiInvoicesModal from "../Banking/UnpaidMultiInvoicesModal";

    export default {
        components: {
            UnpaidMultiInvoicesModal,
            UnpaidMultiInvoiceTableTr,
            UnpaidInvoiceTableRow,
            UnpaidClientInvoiceTableRow,
            UnpaidClientMultiInvoiceTableRow,
            ModelSelect,
            Datetime
        },
        data() {
            return {
                //unpaidInvoices: [],
                unpaidMultiInvoices: [],
                options: [],
                transactionDate: new Date().toISOString(),

                countries: [],
                professional: false,
                roles: [
                    'Visitor',
                    'User',
                    'Manager',
                    'Affiliate',
                    'Admin'
                ],
                isProfessional: false,
                amount: '',
                user: this.$route.params.id,
                type: 1,
                description: '',
                clientName: ''
            }
        },
        computed: {
            success: function () {
                return this.$store.getters.getNewCarSuccessStatus
            },
            isLoading: function () {
                return this.$store.getters.getNewCarLoadingStatus
            },
            userId: function () {
                return this.$store.getters.getNewCarUser
            },
            alertMessage: function () {
                return this.$store.getters.getTransactionStatus
            },
            transactionTotals: function () {
                return this.$store.getters.getTransactionTotals
            },
            getCurrency: function () {
                return this.$store.getters.getTransactionTotals.currency == 2 ? '$' : '¥'
            },
            getAmountUsed: function () {
                let invoiceAmountUsed = this.$store.getters.getInvoiceAmountUsed
                let used_amount = 0;
                invoiceAmountUsed.forEach((invObj) => {
                    used_amount += Number(invObj.amount_used)
                })

                return used_amount
            },
            unpaidInvoices: function (){ return this.$store.getters.getUnpaidAllInvoices}
        },
        methods: {
            getInvoices(){
                apiProformaInvoices
                    .requestUnpaidInvoices(this.user)
                    .then((response) => {
                        this.$store.commit('setUnpaidAllInvoices', response.data.invoices)
                        //this.unpaidInvoices = this.$store.getters.getUnpaidAllInvoices
                        this.unpaidMultiInvoices = response.data.multi_invoices;
                    })
                this.$store.dispatch('getTransactionTotals', this.user)
            },
            setSelectOptions(users) {
                let list = []
                let clientId = this.$route.params.id
                users.forEach((element) => {
                    if(element.id == clientId){
                        this.clientName = element.name
                    }
                    list.push({
                        value: element.id,
                        text: element.name
                    })
                })

                this.options = list
            },
            createTransaction(){
                let invoices = this.$store.getters.getInvoiceAmountUsed
                let data = {
                    client_id: this.user,
                    amount: this.amount,
                    type: this.type,
                    transaction_date: this.transactionDate,
                    description: this.description,
                    invoices: invoices,
                }
                this.$store.dispatch('createBankingTransaction', data)
                setTimeout(() => {
                    this.$store.dispatch('setActiveUserTab', 'client-balance')
                    this.$router.go(-1)
                })
                this.amount = '';
                this.transactionDate = new Date().toISOString();
                this.description = '';
            },
            getTotalDueAmount(){
                let totalDue = 0;
                this.unpaidInvoices.forEach((invoice, index) => {
                    if(invoice.currency == 2 && this.transactionTotals.currency != 2){
                        totalDue += Math.round(invoice.balance_due * invoice.rate) - invoice.paid_amount;
                    }else{
                        totalDue += invoice.balance_due - invoice.paid_amount;
                    }
                })
                return totalDue;
            },
            getTotalPaidAmount(){
                let totalPaid = 0;
                this.unpaidInvoices.forEach((invoice, index) => {
                    totalPaid = invoice.paid_amount;
                });
                return totalPaid;
            },
            cancel(){
                this.$store.dispatch('setActiveUserTab', 'client-balance')
                this.$router.go(-1)
            }
        },
        created() {
            this.$store.commit("setUnpaidAllInvoices", {});
            this.$store.dispatch('setNewCarErrorsToDefault')
            this.$store.commit('setTransactionStatus', '')
            this.$store.commit('resetInvoiceAmountUsed')
            this.$store.commit('setTransactionTotals', {
                moneyIn: 0,
                moneyOut: 0,
                payment: 0,
                subTotal: 0,
                currency: 1
            })

            apiUsers
                .requestAllUsers()
                .then((response) => {
                    this.setSelectOptions(response.data)
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>

    .field.select-client-field .control {
        display: flex;
    }

    .field.select-client-field .control button.button.is-primary {
        margin-left: 10px;
        align-self: center;
    }
    .alert-message {
        margin-bottom: 10px;
    }
    table.table.client-amount-table {
        width: 100%;
    }
    .error-alert {
        background-color: #ffecec;
        color: #b94a48;
        padding: 5px 10px;
        border: 1px solid #ffdde2;
        border-radius: 5px;
        margin-bottom: 10px;
    }
    .client-name {
        background: #fff;
        box-shadow: inset 0 1px 2px rgba(10,10,10,.1);
        padding-bottom: calc(.375em - 1px);
        padding-left: calc(.625em - 1px);
        padding-right: calc(.625em - 1px);
        padding-top: calc(.375em - 1px);
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Balance-Statement/CreateClientTransaction.vue